import apiProfit from '../../api/apiProfit'

const state = {
    profit: {
        users: [],
        markets: [],
        managers: [],
        total_sales: 0,
        total_costs: 0,
        total_profit: 0,
        ratio: 0,
        user_id: null,
        market_id: null,
        manager_id: null,
        invoices: null,
        is_loading: false,
        date_from: null,
        date_to: null,
    },
    invoicePagination: {
        first_page: 1,
        current_page: null,
        last_page: null,
    },
    invoiceQuery: {
        user_id: null,
        market_id: null,
        manager_id: null,
        date_from: null,
        date_to: null,
        order_column: 'created_at',
        order_type: 'DESC',
        page: 1,
    },
    goalQuery: {
        user_id: null,
        manager_goal: null,
    }
}

const getters = {
    getProfitSectionData: (state) => {
        return state.profit
    },
    getProfitSectionInvoicePagination: (state) => {
        return state.invoicePagination
    },
    getProfitSectionInvoiceQuery: (state) => {
        return state.invoiceQuery
    },
    getProfitSectionSelectedManager: (state) => {
        return state.profit.managers.find(function (element) {
            return element.id === state.profit.manager_id
        })
    },
    getProfitSectionGoalQuery: (state) => {
        return state.goalQuery
    }
}

const mutations = {
    updateProfitFieldValue: (state, data) => {
        state.profit[data.field] = data.value
    },
    updateProfitInvoicePaginationFieldValue: (state, data) => {
        state.invoicePagination[data.field] = data.value
    },
    updateProfitInvoiceQueryFieldValue: (state, data) => {
        state.invoiceQuery[data.field] = data.value
    },
    updateProfitGoalQueryFieldValue: (state, data) => {
        state.goalQuery[data.field] = data.value
    },
    updateProfitSectionQuery: (state) => {
        state.invoiceQuery.user_id = state.profit.user_id
        state.invoiceQuery.market_id = state.profit.market_id
        state.invoiceQuery.manager_id = state.profit.manager_id
        state.invoiceQuery.date_from = state.profit.date_from
        state.invoiceQuery.date_to = state.profit.date_to
    },
    changeProfitSectionQueryToDefault: (state) => {
        state.invoiceQuery.user_id = null
        state.invoiceQuery.market_id = null
        state.invoiceQuery.manager_id = null
        state.invoiceQuery.page = 1
        state.profit.user_id = null
        state.profit.market_id = null
        state.profit.manager_id = null
        state.profit.date_from = null
        state.profit.date_to = null
    }
}

const actions = {
    setProfitSectionQueryToDefault: ({ commit }) => {
        commit('changeProfitSectionQueryToDefault')
    },
    setProfitSectionGoalQueryFieldValue: ({ commit }, data) => {
        commit('updateProfitGoalQueryFieldValue', data)
    },
    setProfitSectionFieldValue: ({commit}, data) =>{
        commit('updateProfitFieldValue', data)
    },
    setProfitSectionInvoicePaginationFieldValue: ({commit}, data) =>{
        commit('updateProfitInvoicePaginationFieldValue', data)
    },
    setProfitSectionInvoiceQueryFieldValue: ({commit}, data) =>{
        commit('updateProfitInvoiceQueryFieldValue', data)
    },
    fetchProfitSectionDefaultData: ({ commit }) => {
        commit('updateProfitFieldValue', {field: 'is_loading', value: true})
        apiProfit
            .getProfitRequest()
            .then((response) => {
                commit('updateProfitFieldValue', {field: 'users', value: response.data.users})
                commit('updateProfitFieldValue', {field: 'markets', value: response.data.markets})
                commit('updateProfitFieldValue', {field: 'managers', value: response.data.managers})
                commit('updateProfitFieldValue', {field: 'total_sales', value: response.data.total_sales})
                commit('updateProfitFieldValue', {field: 'total_costs', value: response.data.total_costs})
                commit('updateProfitFieldValue', {field: 'total_profit', value: response.data.total_profit})
                commit('updateProfitFieldValue', {field: 'ratio', value: response.data.ratio})
                commit('updateProfitFieldValue', {field: 'invoices', value: response.data.invoices.data})
                commit('updateProfitInvoicePaginationFieldValue', {field: 'current_page', value: response.data.invoices.current_page})
                commit('updateProfitInvoicePaginationFieldValue', {field: 'last_page', value: response.data.invoices.last_page})
                commit('updateProfitFieldValue', {field: 'is_loading', value: false})
            })
            .catch(error => console.log(error))
    },
    fetchProfitSectionInvoicesWithQuery: ({ commit, state }) => {
        commit('updateProfitFieldValue', {field: 'is_loading', value: true})
        commit('updateProfitSectionQuery')
        apiProfit
            .getProfitInvoicesRequest(state.invoiceQuery)
            .then((response) => {
                commit('updateProfitFieldValue', {field: 'invoices', value: response.data.invoices.data})
                commit('updateProfitFieldValue', {field: 'total_sales', value: response.data.total_sales})
                commit('updateProfitFieldValue', {field: 'total_costs', value: response.data.total_costs})
                commit('updateProfitFieldValue', {field: 'total_profit', value: response.data.total_profit})
                commit('updateProfitFieldValue', {field: 'ratio', value: response.data.ratio})
                commit('updateProfitInvoicePaginationFieldValue', {field: 'current_page', value: response.data.invoices.current_page})
                commit('updateProfitInvoicePaginationFieldValue', {field: 'last_page', value: response.data.invoices.last_page})
                commit('updateProfitFieldValue', {field: 'is_loading', value: false})
            })
            .catch(error => console.log(error))
    },
    downloadProfitSectionInvoicesExcel: ({ commit, state }) => {
        commit('updateProfitFieldValue', {field: 'is_loading', value: true})
        commit('updateProfitSectionQuery')
        apiProfit
            .downloadProfitInvoiceExportInExcelRequest(state.invoiceQuery)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'invoices.xlsx')
                document.body.appendChild(link)
                link.click()
                commit('updateProfitFieldValue', {field: 'is_loading', value: false})
            })
            .catch((error) => {
                console.log(error)
            })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/profit.js